import { render, staticRenderFns } from "./main-book-of-the-month.vue?vue&type=template&id=53147538&"
import script from "./main-book-of-the-month.vue?vue&type=script&lang=js&"
export * from "./main-book-of-the-month.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports